//封装公共的请求api
const apiConfig = {
    // 开发环境
    dev: {
        //https://www.xihengmf.vip/pc
        //http://192.168.8.7:9004/pc
        //http://39.99.32.216:18888/pc
        fayongApi: "https://www.xihengmf.vip/pc"
    },
    // 生产环境
    production: {
        fayongApi: "https://www.xihengmf.vip/pc"
    },
};

// 根据全局变量自动切换请求地址前缀
export default apiConfig[process.env.VUE_APP_ENV];